import ApiAuthorzationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import { Home } from "./components/Home";
import { Productos_Index } from "./components/Productos/ProductosIndex";
import { Proveedores_Index } from "./components/Proveedores/ProveedoresIndex";
import { ProveedorUsuarios_Index } from "./components/ProveedorUsuarios/ProveedorUsuariosIndex";
import { Navieras_Index } from "./components/Navieras/NavierasIndex";
import { Destinos_Index } from "./components/Destinos/DestinosIndex";
import { TiposFruta_Index } from "./components/TiposFruta/TiposFrutaIndex";
import { Cartones_Index } from "./components/Cartones/CartonesIndex";
import { Colillas_Index } from "./components/Colillas/ColillasIndex";
import { EtiquetasCore_Index } from "./components/EtiquetasCore/EtiquetasCoreIndex";
import { EtiquetasCoreProveedor_Index } from "./components/EtiquetasCoreProveedor/EtiquetasCoreProveedorIndex";
import { Contenedores_Index } from "./components/Contenedores/ContenedoresIndex";
import { Barcos_Index } from "./components/Barcos/BarcosIndex";
import { Semanas_Index } from "./components/Semanas/SemanasIndex";
import { SemanasAdmin_Index } from "./components/SemanasAdmin/SemanasAdminIndex";
import { EventosSemanales_Index } from "./components/EventosSemanales/EventosSemanalesIndex";
import { VaporesSemanales_Index } from "./components/VaporesSemanales/VaporesSemanalesIndex";
import { VaporesSemanalesProveedor_Index } from "./components/VaporesSemanalesProveedor/VaporesSemanalesProveedorIndex";
import { ContenedoresSemanales_Index } from "./components/ContenedoresSemanales/ContenedoresSemanalesIndex";
import { BLs_Index } from "./components/BLs/BLsIndex";
import { Paletizados_Index } from "./components/Paletizados/PaletizadosIndex";
import { PaletizadosAdmin_Index } from "./components/PaletizadosAdmin/PaletizadosAdminIndex";
import { PaletizadosVariantes_Index } from "./components/PaletizadosVariantes/PaletizadosVariantesIndex";
import { PaletasBodega_Index } from "./components/PaletasBodega/PaletasBodegaIndex";
import { Calibres_Index } from "./components/Calibres/CalibresIndex";
import { Variantes_Index } from "./components/Variantes/VariantesIndex";
import { VariantesProveedor_Index } from "./components/VariantesProveedor/VariantesProveedorIndex";
import { VariantesAdminReporte_Index } from "./components/VariantesAdminReporte/VariantesAdminReporteIndex";
import { CajasPorPaleta_Index } from "./components/CajasPorPaleta/CajasPorPaletaIndex";
import { ReporteDespacho_Index } from "./components/ReporteDespacho/ReporteDespachoIndex";
import { PaletizadosArchivos_Index } from "./components/PaletizadosArchivos/PaletizadosArchivosIndex";
import { ValoresReferencia_Index } from "./components/ValoresReferencia/ValoresReferenciaIndex";
import { PBI_Analisis } from "./components/Reportes/PBI_Analisis";
import { Paises_Index } from "./components/Paises/PaisesIndex";
import { Puertos_Index } from "./components/Puertos/PuertosIndex";
import { ReportePesos_Index } from "./components/ReportePesos/ReportePesosIndex";
import { ReportePesosAdmin_Index } from "./components/ReportePesosAdmin/ReportePesosAdminIndex";
import { OrseroChat } from "./components/OrseroChat/OrseroChat";

const AppRoutes = [
    {
        index: true,
        requireAuth: true,
        element: <Home />
    },
    {
        path: '/counter',
        requireAuth: true,
        element: <Counter />
    },
    {
        path: '/fetch-data',
        requireAuth: true,
        element: <FetchData />
    },
    {
        path: '/Productos',
        requireAuth: true,
        element: <Productos_Index />
    },
    {
        path: '/Proveedores',
        requireAuth: true,
        element: <Proveedores_Index />
    },
    {
        path: '/Proveedores/:proveedor_Id/Usuarios',
        requireAuth: true,
        element: <ProveedorUsuarios_Index />
    },
    {
        path: '/Navieras',
        requireAuth: true,
        element: <Navieras_Index />
    },
    {
        path: '/Navieras/:naviera_Id/Barcos',
        requireAuth: true,
        element: <Barcos_Index />
    },
    {
        path: '/Destinos',
        requireAuth: true,
        element: <Destinos_Index />
    },
    {
        path: '/Contenedores',
        requireAuth: true,
        element: <Contenedores_Index />
    },
    {
        path: '/Semanas',
        requireAuth: true,
        element: <Semanas_Index />
    },
    {
        path: '/SemanasAdmin',
        requireAuth: true,
        element: <SemanasAdmin_Index />
    },
    {
        path: '/AsistenteOrsero',
        requireAuth: true,
        requiredRole: 'Admin',
        element: <OrseroChat />
    },
    {
        path: '/AsistenteOrsero/ventana',
        requireAuth: true,
        requiredRole: 'Admin',
        element: <OrseroChat standalone />
    },
    {
        path: '/Semanas/:semana_Id/EventosSemanales',
        requireAuth: true,
        element: <EventosSemanales_Index />
    },
    {
        path: '/Semanas/:semana_Id/VaporesSemanales',
        requireAuth: true,
        element: <VaporesSemanales_Index />
    },
    {
        path: '/Semanas/:semana_Id/VaporesSemanalesProveedor',
        requireAuth: true,
        element: <VaporesSemanalesProveedor_Index />
    },
    {
        path: '/Semanas/:semana_Id/PaletizadosVariantes',
        requireAuth: true,
        element: <PaletizadosVariantes_Index />
    },
    {
        path: '/VaporesSemanales/:vaporSemanal_Id/ContenedoresSemanales',
        requireAuth: true,
        element: <ContenedoresSemanales_Index />
    },
    {
        path: '/VaporesSemanales/:vaporSemanal_Id/BLs',
        requireAuth: true,
        element: <BLs_Index />
    },
    {
        path: '/ContenedoresSemanales/:contenedorSemanal_Id/Paletizados',
        requireAuth: true,
        element: <Paletizados_Index />
    },
    {
        path: '/Semanas/:semana_Id/ResumenDeCargas',
        requireAuth: true,
        element: <PaletizadosAdmin_Index />
    },
    {
        path: '/Semanas/:semana_Id/ReportePesos',
        requireAuth: true,
        element: <ReportePesos_Index />
    },
    {
        path: '/Semanas/:semana_Id/ReportePesosAdmin',
        requireAuth: true,
        element: <ReportePesosAdmin_Index />
    },
    {
        path: '/Semanas/:semana_Id/VariantesAdminReporte',
        requireAuth: true,
        element: <VariantesAdminReporte_Index />
    },
    {
        path: '/Semanas/:semana_Id/PaletasBodega',
        requireAuth: true,
        element: <PaletasBodega_Index />
    },
    {
        path: '/TiposFruta',
        requireAuth: true,
        element: <TiposFruta_Index />
    },
    {
        path: '/TiposFruta/:tipoFruta_Id/Calibres',
        requireAuth: true,
        element: <Calibres_Index />
    },
    {
        path: '/Cartones',
        requireAuth: true,
        element: <Cartones_Index />
    },
    {
        path: '/Colillas',
        requireAuth: true,
        element: <Colillas_Index />
    },
    {
        path: '/CajasPorPaleta',
        requireAuth: true,
        element: <CajasPorPaleta_Index />
    },
    {
        path: '/EtiquetasCore',
        requireAuth: true,
        element: <EtiquetasCore_Index />
    },
    {
        path: '/EtiquetasCoreProveedor',
        requireAuth: true,
        element: <EtiquetasCoreProveedor_Index />
    },
    {
        path: '/EtiquetasCore/:etiquetaCore_Id/Variantes',
        requireAuth: true,
        element: <Variantes_Index />
    },
    {
        path: '/VariantesProveedor',
        requireAuth: true,
        element: <VariantesProveedor_Index />
    },
    {
        path: '/ReporteDespacho',
        requireAuth: true,
        element: <ReporteDespacho_Index />
    },
    {
        path: '/PBI_Analisis',
        requireAuth: true,
        element: <PBI_Analisis />
    },
    {
        path: '/ValoresReferencia',
        requireAuth: true,
        element: <ValoresReferencia_Index />
    },
    {
        path: '/Semanas/:semana_Id/PaletizadosArchivos',
        requireAuth: true,
        element: <PaletizadosArchivos_Index />
    },
    {
        path: '/Paises',
        requireAuth: true,
        element: <Paises_Index />
    },
    {
        path: '/Paises/:pais_Id/Puertos',
        requireAuth: true,
        element: <Puertos_Index />
    },
    ...ApiAuthorzationRoutes
];

export default AppRoutes;
